import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { AddButton, Search } from '../../components'
import Card from '../groups/card'
import { connect } from 'react-redux'
import Detail from './detail'
import EditModal from './modals/edit'
import AddModal from './modals/add'
import axios from 'axios'

const useKeys = (initial = []) => {
  let [keys, setKeys] = useState(initial)
  const requestKeys = async () => {
    const { data } = await axios.get('/api/keys')
    setKeys(data)
  }

  useEffect(() => {
    requestKeys()
  }, [])

  const addKey = useCallback(async (key) => {
    await axios.post('/api/keys', key)
    await requestKeys()
  }, [keys])

  const removeKey = useCallback(async (index) => {
    const ActiveKey = keys[index + 1]
    await axios.delete('/api/keys/' + ActiveKey._id)
    await requestKeys()
  }, [keys])

  const editKey = useCallback(async (item) => {
    console.log(item)
    await axios.put('/api/keys/' + item._id, item)
    await requestKeys()
  }, [keys])

  return [keys, addKey, removeKey, editKey]
}
const Keys = ({ collections }) => {
  const [active, setActive] = useState(-1)
  const [keys, addKey, removeKey, editKey] = useKeys([])
  const [isModal, setModal] = useState(false)
  const [isEditModal, setEditModal] = useState(false)
  const [search, setSearch] = useState('')
  const openModal = () => {
    setModal(true)
  }
  const addNewItem = (item) => {
    addKey(item)
    setModal(false)
  }
  const editItem = (item) => {
    editKey(item)
    setEditModal(false)
  }

  const records = keys.filter(key => !search ||
    key.label.toUpperCase().includes(search.toUpperCase())
    || key._id.toUpperCase().includes(search.toUpperCase()))

  const activeKey = records[active + 1]
  return (
    <Fragment>
      <div className="row">
        <div className="col-2 vh-75">
          <label className="mb-2">API KEYS</label>
          <Search onSubmit={(val) => {
            setSearch(val)
            if (active !== -1) {
              setActive(-1)
            }
          }}/>
          <div style={{ height: '78vh', overflow: 'auto' }}>
            {records.
              map((k, i) => (
                <Card name={k.label ? k.label : k._id}
                      iconType={'icon-key1'}
                      setActive={setActive}
                      index={i - 1}
                      type={'key'}
                      isRemove={true}
                      remove={removeKey}
                      isActive={activeKey && (activeKey._id === k._id)}/>))}
          </div>
          <div className={'my-2'}>
            <AddButton id={'addUsers'} label={'Add New Key'}
                       onClick={openModal}/>
          </div>
        </div>
        {activeKey &&
          <Detail item={activeKey}
                  collections={collections}
                  openEdit={() => setEditModal(true)}/>}
      </div>
      <AddModal active={isModal}
                onCancel={() => setModal(false)}
                onOk={addNewItem}
                collections={collections}
                keys={keys}
      />
      {activeKey && <EditModal active={isEditModal}
                               onCancel={() => setEditModal(false)}
                               onOk={editItem}
                               collections={collections}
                               keys={keys}
                               item={activeKey}
      />}

    </Fragment>
  )
}
const mapStateToProps = state => {
  const { collections } = state
  return { collections }
}
export default connect(mapStateToProps)(Keys)
